import React from 'react';
const LabelCard = ({ data, info, checkbox, checkColor, bgColor, text }) => {
	return (
		<div className="LabelCard" style={{ color: text, backgroundColor: bgColor || '' }}>
			{checkbox ? <b style={{ backgroundColor: checkColor }}></b> : ''}

			<span>{data}</span>
			<span>{info}</span>
		</div>
	);
};

export default LabelCard;
